import {
  Redirect,
  RouteComponentProps,
  useLocation,
  useNavigate,
} from "@reach/router";
import instance, { ApiResponse, useFetch } from "api";
import { JumioVerificationStatusResponse } from "./jumioModels";
import { endpoints } from "config";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Toast, ToastMessageReason } from "components/helpers/toast";
import Page from "components/Page";
import { Spinner } from "components/Spinner/Spinner";

const iframeOrigin = "https://netverify.com";
const allowableOrigins = [
  iframeOrigin,
  "https://ibanera.netverify.com",
  "https://ibanera.web.amer-1.jumio.ai",
];

type Props = {} & RouteComponentProps;

export const SignificantPartyJumio: React.FC<Props> = props => {
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState("");
  const navigate = useNavigate();
  const token = useMemo(() => {
    const searchParams = new URLSearchParams(search);
    return searchParams.get("token");
  }, [search]);
  useEffect(() => {
    instance
      .post<ApiResponse<JumioVerificationStatusResponse>>(
        endpoints.jumiomodule.getExternalJumioLink,
        {
          jumioToken: encodeURIComponent(token ?? ""),
          jumioConsent: true,
        }
      )
      .then(res => {
        if (res?.data?.details?.additionalData?.iframeUrl) {
          setUrl(res.data.details.additionalData.iframeUrl);
          // window.location.href = res.data.details.additionalData.iframeUrl;
        }
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => setLoading(false));
  }, [token]);

  const handleMessage = useCallback(
    (e: MessageEvent) => {
      if (isJumioComplete(e)) {
        navigate("/");
        Toast.openToastMessage(
          "Verification complete, we'll be in touch once we've checked your documents",
          ToastMessageReason.VALID,
          { autoClose: false }
        );
      }
    },
    [navigate]
  );

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [handleMessage]);
  return (
    <Page isPublic>
      <div
        className="HeightContent WidthContent"
        style={{ height: "calc(100vh - 120px)", position: "relative" }}
      >
        {loading ? (
          <Spinner positionAbsolute />
        ) : url ? (
          <iframe
            style={{ width: "100%", height: "100%", border: "none" }}
            title="id Verification"
            src={url}
          ></iframe>
        ) : (
          <Redirect to="/" />
        )}
      </div>
    </Page>
  );
};

const isJumioComplete = (e: MessageEvent) => {
  try {
    if (allowableOrigins.includes(e.origin.toLowerCase())) {
      if (typeof e.data === "string") {
        const data = JSON.parse(e.data);
        return data.payload.value === "success";
      } else return e.data.payload.value === "success";
    }
  } catch (e) {
    return false;
  }
};
